import { render, staticRenderFns } from "./DSContReportAssignment.vue?vue&type=template&id=7831beff&lang=pug"
import script from "./DSContReportAssignment.vue?vue&type=script&lang=js"
export * from "./DSContReportAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7831beff')) {
      api.createRecord('7831beff', component.options)
    } else {
      api.reload('7831beff', component.options)
    }
    module.hot.accept("./DSContReportAssignment.vue?vue&type=template&id=7831beff&lang=pug", function () {
      api.rerender('7831beff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/datastudio/DSContReportAssignment.vue"
export default component.exports